import { AppSidebar } from '@frontend/components/layout/AppSidebar';
import { Button } from '@frontend/components/ui/button';
import {
  SidebarInset,
  SidebarProvider,
  useSidebar,
} from '@frontend/components/ui/sidebar';
import { PanelLeft } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

function LayoutContent({ children }: LayoutProps) {
  const { open, toggleSidebar } = useSidebar();

  return (
    <>
      <AppSidebar />
      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <main className="flex-1 p-4">
            <div className="max-w-full-hd mx-auto relative">
              {!open && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={toggleSidebar}
                  className="absolute top-0.5 left-0 z-50 h-8 w-8 text-muted-foreground hover:text-foreground"
                >
                  <PanelLeft className="h-4 w-4" />
                  <span className="sr-only">Open sidebar</span>
                </Button>
              )}
              <div className={!open ? 'pl-10' : ''}>{children}</div>
            </div>
          </main>
        </div>
      </SidebarInset>
    </>
  );
}

export function Layout({ children }: LayoutProps) {
  return (
    <SidebarProvider>
      <LayoutContent>{children}</LayoutContent>
    </SidebarProvider>
  );
}
